import { render, staticRenderFns } from "./AuthorizationVerify.vue?vue&type=template&id=a514c6e2&scoped=true"
import script from "./AuthorizationVerify.vue?vue&type=script&lang=js"
export * from "./AuthorizationVerify.vue?vue&type=script&lang=js"
import style0 from "./AuthorizationVerify.vue?vue&type=style&index=0&id=a514c6e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a514c6e2",
  null
  
)

export default component.exports